const Modal = (function() {
  const openModals = []
  const FOCUSABLE_ELEMENTS = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex^="-"])'
  ]

  function enableScrollBehaviour(toggle) {
    Object.assign(document.body.style, { overflow: toggle ? '' : 'hidden' })
  }

  function addEventListeners(modal) {
    modal.addEventListener('touchstart', onClick)
    modal.addEventListener('click', onClick)
    document.addEventListener('keydown', onKeydown)
  }

  function removeEventListeners(modal) {
    modal.removeEventListener('touchstart', onClick)
    modal.removeEventListener('click', onClick)
    document.removeEventListener('keydown', onKeydown)
  }

  function onClick(e) {
    if (e.target.hasAttribute('data-modal-close')) {
      e.preventDefault()
      closeModal(e)
    }
  }

  function onKeydown(e) {
    if (e.keyCode === 27) closeModal() // esc
    if (e.keyCode === 9) retainFocus(e) // tab
  }

  function retainFocus(event) {
    if (openModals.length === 0) return

    const modal = openModals[openModals.length - 1].modal
    const nodes = modal.querySelectorAll(FOCUSABLE_ELEMENTS)
    if (nodes.length === 0) return

    let focusableNodes = Array.from(nodes)

    /**
     * Filters nodes which are hidden to prevent
     * focus leak outside modal
     */
    focusableNodes = focusableNodes.filter((node) => {
      return node.offsetParent !== null
    })

    if (!modal.contains(document.activeElement)) {
      focusableNodes[0].focus()
    } else {
      const focusedItemIndex = focusableNodes.indexOf(document.activeElement)

      if (event.shiftKey && focusedItemIndex === 0) {
        focusableNodes[focusableNodes.length - 1].focus()
        event.preventDefault()
      }

      if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1) {
        focusableNodes[0].focus()
        event.preventDefault()
      }
    }
  }

  function closeModal() {
    if (openModals.length === 0) return

    const { modal, activeElement, onClose } = openModals.pop()
    modal.setAttribute('aria-hidden', 'true')

    modal.addEventListener('animationend', function handler() {
      modal.classList.remove('is-open')
      modal.removeEventListener('animationend', handler, false)
    }, false)

    removeEventListeners(modal)

    if (openModals.length > 0) {
      // Re-enable the previous modal
      addEventListeners(openModals[openModals.length - 1].modal)
    } else {
      enableScrollBehaviour(true)
    }

    if (activeElement && activeElement.focus) {
      activeElement.focus()
    }

    if (onClose) {
      onClose()
    }
  }

  return { // public interface
    show (id, options = {}) {
      const modal = document.getElementById(id)
      if (!modal) return

      // See if the modal exists in our openModals array.
      const foundIndex = openModals.findIndex((openModal) => openModal.modal === modal)
      if (foundIndex > -1) {
        while (openModals.length > foundIndex + 1) {
          closeModal()
        }
      } else {
        openModals.push(Object.assign(options, {
          modal,
          activeElement: document.activeElement
        }))
        modal.setAttribute('aria-hidden', 'false')
        modal.classList.add('is-open')
        enableScrollBehaviour(false)
        addEventListeners(modal)
      }
      return modal
    },
    close () {
      closeModal()
    }
  }
})()

export default Modal
